import React, { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../../config";
import CreateModule from "./CreateModule";
import UpdateModule from "./UpdateModule";
import CreateLesson from "./CreateLesson";
import UpdateLesson from "./UpdateLesson";
import UpdateCourse from "./UpdateCourse";
import imageCompression from 'browser-image-compression';

const apiUrl = config.apiUrl;
const imageUrl = config.imageUrl;

const ViewCourses = () => {
  const [courses, setCourses] = useState([]);
  const [modules, setModules] = useState([]);
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [editingItem, setEditingItem] = useState(null); // Track the item being edited
  const [editingCourse, setEditingCourse] = useState(null);
  const [memberships, setMemberships] = useState([]);
  const [updateCourse, setUpdateCourse] = useState({
    sort_order: "",
    name: "",
    instructor: "",
    desc: "",
    curriculum: "",
    duration: "",
    price: "",
    offer_price: "",
    image: null,
    membership_type: "",
  });

  const [formData, setFormData] = useState({
    sort_order: "",
    moduleTitle: "",
    title: "",
    videoUrl: "",
    description: "",
    resources: "",
  });

  const [compressedImage, setCompressedImage] = useState(null);
  const [isCompressing, setIsCompressing] = useState(false);

  const [showCreateLesson, setShowCreateLesson] = useState(false);


  console.log("ViewCourses component rendered", modules);

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [coursesResponse, modulesResponse, lessonsResponse, memberships] = await Promise.all([
          axios.get(`${apiUrl}/courses`),
          axios.get(`${apiUrl}/modules`),
          axios.get(`${apiUrl}/lessons`),
          axios.get(`${apiUrl}/memberships`)
        ]);
        
        // Sort courses by sort_order
        const sortedCourses = coursesResponse.data.courses.sort((a, b) => a.sort_order - b.sort_order);
        setCourses(sortedCourses);
        
        // Sort modules by sort_order
        const sortedModules = modulesResponse.data.modules.sort((a, b) => a.sort_order - b.sort_order);
        setModules(sortedModules);
        
        // Sort lessons by sort_order
        const sortedLessons = lessonsResponse.data.lessons.sort((a, b) => a.sort_order - b.sort_order);
        setLessons(sortedLessons);
        
        setMemberships(memberships.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Handle Select Course for Adding Modules and Lessons
  const handleCourseClick = (course) => {
    setSelectedCourse(course);
    setSelectedModule(null); // Reset selected module
    setEditingItem(null); // Reset editing item
  };

  const handleModuleClick = (module) => {
    setSelectedModule((prevModule) =>
      prevModule?.id === module.id ? null : module // Toggle module selection
    );
    setEditingItem(null); // Reset editing item
  };

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Module Addition
  const handleAddModule = async (e) => {
    e.preventDefault();
    if (!selectedCourse) {
      setError("No course selected.");
      return;
    }

    try {
      const newModule = {
        course_id: selectedCourse.id,
        sort_order: formData.sort_order,
        moduleTitle: formData.moduleTitle
      };
      await axios.post(`${apiUrl}/modules`, newModule);
      const response = await axios.get(`${apiUrl}/modules`);
      setModules(response.data.modules);
      alert("Module added successfully.");
      setFormData({ moduleTitle: "", sort_order:"" }); // Clear form after adding
    } catch (err) {
      console.error("Error adding module:", err);
    }
  };

  // Handle Lesson Addition
  const handleAddLesson = async (e) => {
    e.preventDefault();
    if (!selectedModule) {
      setError("No module selected.");
      return;
    }

    try {
      const newLesson = {
        module_id: selectedModule.id,
        sort_order: formData.sort_order,
        title: formData.title,
        videoUrl: formData.videoUrl,
        description: formData.description,
        resources: formData.resources
      };
      await axios.post(`${apiUrl}/lessons`, newLesson);

      const response = await axios.get(`${apiUrl}/lessons`);
      setLessons(response.data.lessons);
      alert("Lesson added successfully.");
      setFormData({ sort_order:"", title: "", videoUrl: "", description: "", resources: "" });
    } catch (err) {
      console.error("Error adding lesson:", err);
    }
  };

  // Handle Edit Button Click for Module or Lesson
  const handleEditClick = (type, item) => {
    setEditingItem({ type, id: item.id }); // Track the editing item
    if (type === "module") {
      setFormData({
        sort_order: item.sort_order || "",
        moduleTitle: item.moduleTitle || "",
      });
    } else if (type === "lesson") {
      setFormData({
        sort_order: item.sort_order || "",
        title: item.title || "",
        videoUrl: item.videoUrl || "",
        description: item.description || "",
        resources: item.resources || ""
      });
    }
  };

  // Handle Update Item (Module or Lesson)
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();

    if (!editingItem) {
      setError("No item selected for editing.");
      return;
    }

    

    try {
      const data = editingItem.type === "module"
        ? { 
          course_id: selectedCourse.id,
          sort_order: formData.sort_order,
          moduleTitle: formData.moduleTitle 
        }
        : { module_id: selectedModule.id, sort_order: formData.sort_order, title: formData.title, videoUrl: formData.videoUrl, description: formData.description, resources: formData.resources };


        console.log(data);

      await axios.put(`${apiUrl}/${editingItem.type}supdate/${editingItem.id}`, data);
      alert(`${editingItem.type.charAt(0).toUpperCase() + editingItem.type.slice(1)} updated successfully.`);

      if (editingItem.type === "module") {
        setModules((prev) =>
          prev.map((item) =>
            item.id === editingItem.id ? { ...item, ...formData } : item
          )
        );
      } else if (editingItem.type === "lesson") {
        setLessons((prev) =>
          prev.map((item) =>
            item.id === editingItem.id ? { ...item, ...formData } : item
          )
        );
      }

      setEditingItem(null); // Reset editing state
    } catch (err) {
      console.error(`Error updating ${editingItem.type}:`, err?.response?.data?.message);
    }
  };


  // Handle Delete for module or lesson
const handleDelete = async (type, id) => {
  if (window.confirm(`Are you sure you want to delete this ${type}?`)) {
    try {
      await axios.delete(`${apiUrl}/${type}delete/${id}`);
      alert(`${type.charAt(0).toUpperCase() + type.slice(1)} deleted successfully.`);

      if (type === "module") {
        setModules((prev) => prev.filter((item) => item.id !== id));
      } else if (type === "lesson") {
        setLessons((prev) => prev.filter((item) => item.id !== id));
      }
    } catch (err) {
      console.error(`Error deleting ${type}:`, err);
    }
  }
};


const handleEditCourseClick = (course) => {
    setEditingCourse(course);
    setUpdateCourse({
      sort_order: course.sort_order,
      name: course.name,
      instructor: course.instructor,
      desc: course.desc,
      curriculum: course.curriculum,
      duration: course.duration,
      price: course.price,
      offer_price: course.offer_price,
      image: course.image,
      membership_type: course.membership_type,
    });
  };
  
  // Handle Input Changes
  const handleCourseChange = async (e) => {
  const { name, value, files } = e.target;

  if (files && files.length > 0) {
    const file = files[0];
    if (!file) return;

    setIsCompressing(true);

    try {
      const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
        fileType: 'image/webp'
      };

      const compressedBlob = await imageCompression(file, options);
      
      const fileName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
      const compressedFile = new File([compressedBlob], fileName, {
        type: "image/webp",
        lastModified: Date.now()
      });


      setCompressedImage(compressedFile);

      setUpdateCourse((prev) => ({ ...prev, [name]: compressedFile }));
    } catch (error) {
      console.error('Error compressing image:', error);
    } finally {
      setIsCompressing(false);
    }
  } else {
    setUpdateCourse((prev) => ({ ...prev, [name]: value }));
  }
};


  
    const handleCourseUpdateSubmit = async (e) => {
      e.preventDefault();
      const data = new FormData();
      data.append("_method", "PUT");
      
      data.append("sort_order", updateCourse.sort_order);
      data.append("name", updateCourse.name);
      data.append("instructor", updateCourse.instructor);
      data.append("desc", updateCourse.desc);
      data.append("curriculum", updateCourse.curriculum);
      data.append("duration", updateCourse.duration);
      data.append("price", updateCourse.price);
      data.append("offer_price", updateCourse.offer_price?? '');
      data.append("membership_type", updateCourse.membership_type);

      // Only append image if it exists and is a File object
      if (updateCourse.image instanceof File) {
        data.append("image", updateCourse.image);
      } else if (typeof updateCourse.image === 'string') {
        // If it's a string (existing image path), don't append as file
        data.append("existing_image", updateCourse.image);
      }

      // Debug: Log FormData contents
      for (let [key, value] of data.entries()) {
        console.log(key, value);
      }
      
      try {
        await axios.post(`${apiUrl}/coursesupdate/${editingCourse.id}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        alert("Course updated successfully.");
        setCourses((prev) =>
          prev.map((course) => (course.id === editingCourse.id ? { ...course, ...updateCourse } : course))
        );
        setEditingCourse(null);
      } catch (err) {
        console.error("Error updating course:", err?.response?.data?.message);
      }
    };
  
    
    // Handle Course Delete
    const handleDeleteCourse = async (id) => {
      if (window.confirm("Are you sure you want to delete this course?")) {
        try {
          await axios.delete(`${apiUrl}/coursedelete/${id}`);
          alert("Course deleted successfully.");
          setCourses((prev) => prev.filter((course) => course.id !== id));
        } catch (err) {
          console.error("Error deleting course:", err);
        }
      }
    };


  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Course List</h2>
      {error && <p className="text-red-500">{error}</p>}
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            <th className="border border-gray-300 px-4 py-2">Image</th>
            <th className="border border-gray-300 px-4 py-2">Name</th>
            <th className="border border-gray-300 px-4 py-2">Instructor</th>
            <th className="border border-gray-300 px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {courses.map((course) => (
            <tr key={course.id}>
              <td className="border border-gray-300 px-4 py-2">
                {course.image && (
                  <img
                    src={`${imageUrl}/${course.image}`}
                    alt="Course"
                    className="h-12 w-12 object-cover"
                  />
                )}
              </td>
              <td className="border border-gray-300 px-4 py-2">{course.name}</td>
              <td className="border border-gray-300 px-4 py-2">{course.instructor}</td>
              <td className="border border-gray-300 px-4 py-2">
                <button
                  onClick={() => handleCourseClick(course)}
                  className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                >
                  View & Add Modules/Lessons
                </button>
              </td>
              <td className="border px-4 py-2">
                <button onClick={() => handleEditCourseClick(course)} className="bg-yellow-600 text-white px-3 py-1 rounded hover:bg-yellow-700 mr-2">
                  Edit
                </button>
                <button onClick={() => handleDeleteCourse(course.id)} className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700">
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {editingCourse && (   
        <div className="mt-6">
          <UpdateCourse 
              updateCourse={updateCourse}
              memberships={memberships}
              imageUrl={imageUrl}
              handleCourseChange={handleCourseChange}
              handleCourseUpdateSubmit={handleCourseUpdateSubmit}
              onClose={() => setEditingCourse(null)}
          />
        </div>
      )}


      {selectedCourse && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-10">
             {/* Header with close button */}
              <div className="flex justify-end items-center mb-6">
                  <button
                      onClick={() => setSelectedCourse(null)}
                      className="text-gray-500 hover:text-gray-700 text-2xl"
                      aria-label="Close modal"
                  >
                      &times;
                  </button>
              </div>
          {/* ADD MODULE FORM */}
          {!editingItem && (
            <CreateModule
              formData={formData}
              handleChange={handleChange}
              handleAddModule={handleAddModule}
              selectedCourse={selectedCourse}
            />
          )}

          {/* EDIT MODULE FORM */}
          {editingItem?.type === "module" && (
           <UpdateModule
            formData={formData}
            handleChange={handleChange}
            handleUpdateSubmit={handleUpdateSubmit}
           />
          )}

          <h2 className="text-2xl font-bold mb-4 mt-8">Module List for {selectedCourse.name}</h2>
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr>
                <th className="border border-gray-300 px-4 py-2">Module Name</th>
                <th className="border border-gray-300 px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {modules
                .filter((module) => module && selectedCourse && module.course_id === selectedCourse.id)
                .map((module) => (
                  <React.Fragment key={module.id}>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">{module.moduleTitle}</td>
                      <td className="border border-gray-300 px-4 py-2">
                        <button
                          onClick={() => handleModuleClick(module)}
                          className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                        >
                          {selectedModule?.id === module.id ? "Hide Lessons" : "Show Lessons"}
                        </button>
                        <button
                          onClick={() => handleEditClick("module", module)}
                          className="bg-yellow-600 text-white px-3 py-1 rounded hover:bg-yellow-700 mr-2"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete("module", module.id)}
                          className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>

                    {selectedModule?.id === module.id && (
                      <tr>
                        
                        <td colSpan="2">
                          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-10">
                               {/* Header with close button */}
                              <div className="flex justify-between items-center mb-6">
                                <h3 className="text-lg font-bold mt-4">Lessons for {selectedModule.moduleTitle}</h3>
                                <button
                                    onClick={() => setSelectedModule(null)} 
                                    className="text-gray-500 hover:text-gray-700 text-2xl"
                                    aria-label="Close modal"
                                >
                                    &times;
                                </button>
                              </div>
                             
                                {lessons.filter((lesson) => lesson.module_id === module.id).length > 0 ? (
                                  <ul className="list-disc list-inside">
                                    {lessons
                                      .filter((lesson) => lesson.module_id === module.id)
                                      .map((lesson) => (
                                        <li key={lesson.id} className="ml-6">
                                          {lesson.title}
                                          <button
                                            onClick={() => handleEditClick("lesson", lesson)}
                                            className="bg-yellow-600 text-white px-3 py-1 rounded hover:bg-yellow-700 ml-2"
                                          >
                                            Edit
                                          </button>
                                          <button
                                            onClick={() => handleDelete("lesson", lesson.id)}
                                            className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 ml-2"
                                          >
                                            Delete
                                          </button>
                                        </li>
                                      ))}
                                  </ul>
                                ) : (
                                  <p>No lessons available for this module.</p>
                                )}

                                {/* ADD LESSON FORM */}
                                {!editingItem && (
                                <div className="mt-4">
                                  {!showCreateLesson ? (
                                    <button
                                      onClick={() => setShowCreateLesson(true)}
                                      className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                                    >
                                      Create New Lesson
                                    </button>
                                  ) : (
                                    <button
                                      onClick={() => setShowCreateLesson(false)}
                                      className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 mb-4"
                                    >
                                      Close
                                    </button>
                                  )}
                                  
                                  {showCreateLesson && (
                                    <CreateLesson 
                                      formData={formData}
                                      setFormData={setFormData}
                                      handleChange={handleChange}
                                      handleAddLesson={(e) => {
                                        handleAddLesson(e);
                                        setShowCreateLesson(false); // Submit করলে ফর্ম বন্ধ হবে
                                      }}
                                      onClose={() => setShowCreateLesson(false)}
                                    />
                                  )}
                                </div>
                              )}

                              {/* EDIT LESSON FORM */}
                              {editingItem?.type === "lesson" && (
                                <UpdateLesson 
                                  setFormData={setFormData}
                                  formData={formData}
                                  onClose={() => setEditingItem(null)}
                                  handleChange={handleChange}
                                  handleUpdateSubmit={handleUpdateSubmit}
                                />
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
            </tbody>
          </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewCourses;
